import React, { useEffect, useRef, useState } from 'react';
import { Modal, Card, message } from 'antd';
import HlsJsPlayer from 'xgplayer-hls.js';
import Player from 'xgplayer';

const ModalVideo = (props) => {
  // eslint-disable-next-line react/prop-types
  const { src, visible, onCancel, title } = props;
  const ref = useRef();
  const [player, setPlayer] = useState();

  useEffect(() => {
    if (visible) {
      playVideo();
    } else {
      player?.pause();
      player?.destroy();
    }
  }, [ref, src, visible]);

  function createPlayerConfig() {
    return {
      id: 'player',
      url: src,
      autoplay: true,
      playbackRate: [0.5, 0.75, 1, 1.5, 2],
      muted: true,
      screenShot: {
        saveImg: true,
        quality: 1,
        type: 'image/png',
        format: '.png',
      },
      cssFullscreen: true, // 网页样式全屏
      fluid: true,
      enableContextmenu: true, // 右键菜单
      volume: 0.0,
      download: true, // 设置download控件显示
    };
  }

  const playVideo = () => {
    if (!src) {
      message.warn('视频URL为空！');
      return;
    }
    setTimeout(function () {
      // eslint-disable-next-line react/prop-types
      if (src.toLowerCase().endsWith('.m3u8')) {
        // eslint-disable-next-line no-new
        const player = new HlsJsPlayer(createPlayerConfig());
        setPlayer(player);
      } else {
        // eslint-disable-next-line no-new
        const player = new Player(createPlayerConfig());
        setPlayer(player);
      }
    }, 100);
  };

  return (
    <Modal
      destroyOnClose
      title={title ?? '视频详情'}
      width={800}
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Card bordered={false}>
        <div id="player"></div>
      </Card>
    </Modal>
  );
};

export default ModalVideo;
